import { createAutocompleteOptionLoader } from "~/utils/Forms/Autocomplete";
import { FormKitNode } from "@formkit/core";

/**
 * When an autocomplete input has an optionSource property, this plugin will add an optionLoader property to the node.
 * The optionLoader property is a function that hydrates the autocomplete's selected option.
 */
const plugin = (node: FormKitNode) => {
  if (node.type === "input" && node.props.type === "autocomplete") {
    // Add properties to the base node
    node.addProps(["optionSource"]);
    node.addProps(["optionLabelTemplate"]);
    node.addProps(["optionsLabelTemplate"]);

    // Set the loaders if these properties are on the node
    if (node.props.optionSource) {
      node.props.optionLoader = createAutocompleteOptionLoader(
        node.props.optionSource,
        {
          optionLabelTemplate:
            node.props?.optionLabelTemplate ||
            node.props?.optionsLabelTemplate ||
            "{{ name }}"
        }
      );
    }
  }
};

export default plugin;
